import { Link, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../../utils/api';
import ModulePageHeading from '../../components/ModulePageHeading';
import { resolveNetworkNav } from '../../navigation/networkNavigation';

function formatDate(v) {
  if (!v) return '—';
  try {
    return new Date(v).toLocaleDateString();
  } catch {
    return String(v);
  }
}

export default function BuildingSsHistory() {
  const { orgId, buildingId } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['service-network', 'building-ss-history', buildingId],
    queryFn: async () => (await api.get(`/service-network/buildings/${buildingId}/ss-history`)).data?.data,
    enabled: !!buildingId,
  });

  const building = data?.building;
  const rows = data?.ss_history ?? [];

  return (
    <div>
      <ModulePageHeading
        resolveNav={resolveNetworkNav}
        title={building?.name ? `${building.name} — SS history` : 'Building SS history'}
        showBack
        backTo={orgId ? `/network/org/${orgId}` : '/network?tab=agent'}
        backLabel="Back to company"
        infoTitle="Building SS history"
        infoChildren={
          <p>
            Past inspection work for every Specified System on this building. Click an SS to see the date-by-date list.
          </p>
        }
        actions={
          buildingId ? (
            <button
              type="button"
              onClick={() => navigate(`/buildings/${buildingId}`)}
              className="text-sm text-primary-700 hover:underline"
            >
              Open building →
            </button>
          ) : null
        }
      />

      {building?.address && <p className="text-sm text-gray-500 mb-4">{building.address}</p>}

      {isLoading ? (
        <p className="text-sm text-gray-500">Loading…</p>
      ) : rows.length === 0 ? (
        <p className="text-sm text-gray-500 bg-white border rounded-lg p-6 text-center">
          No SS instances or inspection jobs recorded for this building yet.
        </p>
      ) : (
        <div className="bg-card rounded-lg border border-gray-200 divide-y divide-gray-100">
          {rows.map((row) => (
            <button
              key={row.ss_code}
              type="button"
              onClick={() =>
                navigate(
                  `/network/org/${orgId}/buildings/${buildingId}/ss/${encodeURIComponent(row.ss_code)}`
                )
              }
              className="w-full text-left px-4 py-3 hover:bg-slate-50 flex flex-wrap items-center justify-between gap-2"
            >
              <div>
                <p className="font-semibold text-gray-900">
                  {row.ss_code}
                  {row.ss_name && row.ss_name !== row.ss_code ? (
                    <span className="font-normal text-gray-600"> · {row.ss_name}</span>
                  ) : null}
                </p>
                <p className="text-xs text-gray-500 mt-0.5">
                  {row.job_count} job{row.job_count === 1 ? '' : 's'}
                  {row.last_date ? ` · last ${formatDate(row.last_date)}` : ''}
                  {row.last_overall_status ? ` · ${row.last_overall_status}` : row.last_status ? ` · ${row.last_status}` : ''}
                </p>
              </div>
              <span className="text-xs text-primary-700 font-medium">Date list …</span>
            </button>
          ))}
        </div>
      )}

      {orgId && (
        <p className="mt-4 text-xs text-gray-400">
          <Link to={`/network/org/${orgId}`} className="hover:underline">
            ??Company
          </Link>
        </p>
      )}
    </div>
  );
}
